module.exports = __webpack_public_path__ + "img/no-image.6e944b03.svg";